import { Box } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const InvoiceItemWarningMessageContainer = styled(Box)`
  padding-right: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.MD}) {
    display: none;
  }
`
